(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["presale-code"] && !Shopify.designMode) return;
  try {
    class PresaleCodeReadout extends HTMLElement {
    constructor(){
        super();
        this.presaleCode = false
        this.totalRetryCount = 0
        this.maxRetries = 10
        this.retryFactor = 5

        this.helpTextUpdateInterval = 0
        this.loadingMessageText = "Loading your code..."
    } 
    
    connectedCallback(){
        this.codeRetrievalUrl = this.getAttribute("code-retrieval-url")
        this.render();
    }

    moreRetriesPossible(){
        return this.totalRetryCount < this.maxRetries
    }
    
    retryCodeRetrieval() {
        if(!this.moreRetriesPossible()) {
        console.log("Giving up on retries")
        window.clearInterval(this.helpTextUpdateInterval)
        this.updateErrorText()
        return
        }
        
        const msToWait = (2 ** this.totalRetryCount * this.retryFactor) * 1000
        this.nextRetryAttemptAt = (new Date()).getTime() + msToWait
        console.log("Starting retry loop, Waiting...", msToWait)
        window.setTimeout(this.loadPresaleCode.bind(this), msToWait)

        if(!this.helpTextUpdateInterval) {
        this.helpTextUpdateInterval = window.setInterval(this.updateErrorText.bind(this), 1000)  
        }
    }
    
    async loadPresaleCode() {
        try {
        this.totalRetryCount++
        this.textContent = this.loadingMessageText

        if(window.location.hash.includes('test__code-retrieve-fail')) {
            throw "Code retrieval failed because the URL indicates you wanted to test the error scenario."
        }
        
        const fetchResult = await fetch(this.codeRetrievalUrl)
        const apiResponse = await fetchResult.json()
        if(!apiResponse || apiResponse.error) {
            return this.onPresaleCodeError(apiResponse.error)
        }
        this.presaleCode = apiResponse.code_string.trim()
        this.onPresaleCodeRetrieved()
        } catch(e) {
        this.onPresaleCodeError(e.message)
        }
    }

    updateErrorText() {
        if(this.moreRetriesPossible()){
        var retryTimer = Math.floor((this.nextRetryAttemptAt - (new Date()).getTime()) / 1000)
        var retryCount = `${this.totalRetryCount} time`
        if(this.totalRetryCount > 1) {
            retryCount += "s"
        }
        var nextStepsMessage = `Hold on. We've tried ${retryCount}, but we'll try again in ${retryTimer} seconds...`
        } else {
        var nextStepsMessage = `"Sorry, we tried ${this.totalRetryCount} times but it's still not working.<br/>You can try refreshing the page or <a href='/pages/contact'>click here to contact us for help.</a>`
        }

        this.errorTextContainer.innerHTML = nextStepsMessage
    }

    onPresaleCodeRetrieved() {
        //console.log("Presale code retrieved")
        this.innerHTML = `<p class="presale-code__text">Your unique presale code is</p><p class="presale-code__string">${this.presaleCode}</p><p class="presale-code__footer">Don't share this code &mdash; it's unique to you and can only be used once</p>`
        this.setAttribute('data-presale-code', this.presaleCode)

        this.dispatchEvent(
        new CustomEvent("presale-code:available", {
            bubbles: true,
            detail: { presaleCode: () => this.presaleCode },
        })
        );
    }
    onPresaleCodeError(errorMessage) {
        this.innerHTML = `<p class="presale-code__text">Oh no! An unexpected error occurred when fetching your presale code</p>`

        this.errorTextContainer = document.createElement('span')
        this.errorTextContainer.classList.add('presale-retrieval-error-status')
        this.appendChild(this.errorTextContainer)
        
        this.retryCodeRetrieval()
    }
    
    render(){
        this.textContent = this.loadingMessageText
        this.loadPresaleCode()
    }
    }
    window.customElements.define('presale-code-readout', PresaleCodeReadout);
  } catch(e) { console.error(e); }
})();

})();
